var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-safe"},[_c('img',{attrs:{"src":_vm.image}}),_vm._v(" "),_c('p',{staticClass:"t-sans"},[_vm._v("Ware operates a Rave Safe policy - if you find yourself feeling uncomfortable, please speak to a member of the team and they will assist you.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21d32d4d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SafetyNotice.vue
// module id = null
// module chunks = 